import { css } from 'styled-components';
export const injectOSXFontSmoothing = (enable) => css `
  -moz-osx-font-smoothing: ${enable ? 'grayscale' : 'auto'};
  -webkit-font-smoothing: ${enable ? 'antialiased' : 'auto'};
`;
//# sourceMappingURL=injectOSXFontSmoothing.js.map